(function($){
	'use strict';

	$.fn.accountSelect = function(method) {
		if (serviceSelectMethods[method]) {
            return serviceSelectMethods[ method ].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return serviceSelectMethods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' is not defined for jQuery.accountSelect');
        }
	};

	var serviceSelectMethods = {
		init: function(params) {
			if($("select.providers.missed-current-value", this).length) {
				$("select.accounts", this).prop("disabled", "disabled");
				$("select.items", this).prop("disabled", "disabled");
			}

			$("select.accounts", this).selectize();
			$("select.items", this).selectize();

			$("select.providers", this).on("change", function() {
				var $providers = $(this),
					$row = $providers.closest("div.row") || $providers.closest("form"),
					$accounts = $("select.accounts", $row),
					$items = $("select.items", $row),
					tmp = "<option value=\"\">" + $providers.attr("data-prompt") + "</option>",
					uid = $providers.val();

				if($accounts.hasClass("loading"))
					return false;

				if($items.length)
					$items.html("<option value=\"\">" + $items.attr("data-prompt") + "</option>");

				if(!uid) {
					$accounts.html(tmp);
				} else {
					$accounts.html("<option value=\"\">" + $providers.attr("data-loading") + "</option>");
					$accounts.addClass("loading");
					$.ajax({
						url: $providers.attr("data-url"),
						data: $.extend({type: "accounts", provider: uid}, App.csrf||{}),
						type: "post",
						dataType: "json"
					}).done(function(data) {
						var temp=[tmp];
						if(data.ok){
							var selectize = $accounts[0].selectize;

							selectize.clear();
							selectize.clearCache();
							selectize.clearOptions(true);

							$.each(data.items, function(k,v){
								temp.push("<option value=\""+k+"\">"+v+"</option>");
								selectize.addOption({
									'value': k,
									'text': v
								});
							});

							// clear items
							selectize = $items[0].selectize;
							selectize.clear();
							selectize.clearCache();
							selectize.clearOptions(true);
						}
						$accounts.html(temp.join(""));
					}).always(function() {
						$accounts.removeClass("loading");
						$accounts.prop("disabled", "");
						$accounts.removeProp("disabled");
					});
				}
				return true;
			});

			$("select.accounts", this).on("change", function() {
				var $accounts = $(this),
					$row = $accounts.closest("div.row") || $accounts.closest("form"),
					$items = $("select.items", $row),
					tmp = "<option value=\"\">" + $accounts.attr("data-prompt") + "</option>",
					uid = $accounts.val();

				if($items.hasClass("loading"))
					return false;

				if(!uid) {
					$items.html(tmp);
				} else {
					$items.html("<option value=\"\">" + $accounts.attr("data-loading") + "</option>");
					$items.addClass("loading");
					$.ajax({
						url: $accounts.attr("data-url"),
						data: $.extend({type: $accounts.data('type'), account: uid}, App.csrf||{}),
						type: "post",
						dataType: "json"
					}).done(function(data) {
						var temp=[tmp];
						if(data.ok){
							var selectize = $items[0].selectize;

							selectize.clear();
							selectize.clearCache();
							selectize.clearOptions(true);

							$.each(data.items, function(k,v){
								temp.push("<option value=\""+k+"\">"+v+"</option>");
								selectize.addOption({
									'value': k,
									'text': v
								});
							});
						}
						$items.html(temp.join(""));
					}).always(function(){
						$items.removeClass("loading");
						$items.prop("disabled", "");
						$items.removeProp("disabled");
					});
				}
				return true;
			});
		}
	};

	$(document).ready(function(){
		var opts = {};
		$('.account-select').each(function(){
			$(this).accountSelect(opts);
		})
	});

})(jQuery);